export const slugifyBook = (bookNumber, chapterNumber = 0) => {
	const bookpath = '/books/1'+String(bookNumber).padStart(2, '0')+'/';
	const chapterpath = chapterNumber > 0 ? String(chapterNumber).padStart(3, '0')+'/' : '';
	return bookpath+chapterpath;
};

export const slugifyShow = (showTitle, seasonNumber = 0, episodeNumber = 0) => {
	const showpath = '/'+showTitle.replace(/[^A-Za-z0-9]/gi, '').toLowerCase()+'/';
	const seasonpath = seasonNumber > 0 ? seasonNumber+'/' : '';
	const episodepath = episodeNumber > 0 ? String(episodeNumber).padStart(2, '0')+'/' : '';
	return showpath+seasonpath+episodepath;
};

export const slugifyHandle = (handle) => {
	return handle.replace(/[^A-Za-z0-9]/gi, '').toLowerCase();
};

export const formatLocaleTime = (isostring, showTime = true) => {
	const dt = new Date(isostring);
	const d = dt.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
	const t = showTime ? dt.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric', timeZoneName: 'short' }) : '';
	return `${d} ${t}`.trim();
};

export const getInteract = (frontmatter, type) => {
	const interact = {};
	if (frontmatter.interact) {
		frontmatter.interact.forEach(f => {
			const fSplit = f.split('=');
			interact[fSplit[0]] = parseInt(fSplit[1]);
		});
	}
	return interact[type];
};